var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.base.categoria_base.tiene_indumentarias)?_c('IndumentariasComponent',{attrs:{"base":_vm.base,"paso_activo":true},on:{"terminado":_vm.terminar,"volver":_vm.volver}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }